// Extracted from web/App.tsx; behavior and declaration bodies preserved.
export function ExpandWorkspaceIcon({size=18}: {size?:number}) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M9 9 3 3m0 5V3h5M15 9l6-6m-5 0h5v5M9 15l-6 6m5 0H3v-5M15 15l6 6m0-5v5h-5"/></svg>;
}
export function RestoreWorkspaceIcon({size=18}: {size?:number}) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="m3 3 6 6M4 9h5V4m12-1-6 6m0-5v5h5M3 21l6-6m-5 0h5v5m12 1-6-6m0 5v-5h5"/></svg>;
}
export function LayersIcon(props: any) {
  return <Layers3Icon {...props} />;
}
export function Layers3Icon({ size = 18 }: any) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="m12 3 10 6-10 6L2 9l10-6Zm-9 11 9 5 9-5M3 18l9 5 9-5" />
    </svg>
  );
}
